import Immutable from 'immutable';
import {
  FLAG_GETTING_LIQUIDATION_SESSIONS,
  GET_LIQUIDATION_SESSIONS,
  CLEAR_LIQUIDATION_SESSIONS,
  GET_LIQUIDATION_SESSION,
  CLEAR_LIQUIDATION_SESSION,
  FLAG_LIQUIDATION_SESSION_ACTIVITY,
} from '../../../actions/types/sales';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LIQUIDATION_SESSIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_LIQUIDATION_SESSIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_LIQUIDATION_SESSIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_LIQUIDATION_SESSION:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_LIQUIDATION_SESSION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_LIQUIDATION_SESSION_ACTIVITY:
      // raising flag
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
